





















import Vue from 'vue';
import CountryFlag from 'vue-country-flag';

export default Vue.extend({
  components: {
    CountryFlag,
  },
  props: {
    value: String,
    short: Boolean,
    noText: Boolean,
  },
  data: function() {
    return {
      items: [
        {
          flag: 'US',
          text: 'English',
          value: 'en',
        },
        {
          flag: 'ES',
          text: 'Español',
          value: 'es',
        },
      ],
    };
  },
});
